import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = { class: "o-box u-bg-color-5 -box-padding-sm" }
const _hoisted_3 = { class: "o-title-3" }
const _hoisted_4 = { class: "o-title-4" }
const _hoisted_5 = { class: "o-box__inner" }
const _hoisted_6 = { class: "o-box__item" }
const _hoisted_7 = { class: "o-form" }
const _hoisted_8 = { class: "o-form-row -col-1/2" }
const _hoisted_9 = { class: "o-form__item" }
const _hoisted_10 = { class: "o-select__wrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "admission-type"
}, null, -1 /* HOISTED */)
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value", "innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  "aria-hidden": "true",
  tabindex: "-1",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_15 = { class: "o-form__item" }
const _hoisted_16 = { class: "o-select__wrap" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "admission-type"
}, null, -1 /* HOISTED */)
const _hoisted_18 = { value: "" }
const _hoisted_19 = ["value", "innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  "aria-hidden": "true",
  tabindex: "-1",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_21 = { class: "c-admission-preparation__wrap js-admission-preparation__wrap" }
const _hoisted_22 = { class: "c-admission-result" }
const _hoisted_23 = { class: "c-admission-result__item" }
const _hoisted_24 = { class: "o-grid" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "o-grid-8" }
const _hoisted_27 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString($options.t("Personnes-ressources selon votre programme")), 1 /* TEXT */),
      _createElementVNode("h4", _hoisted_4, _toDisplayString($options.t("Veuillez sélectionner un type et un nom de programme :")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedFilter1) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_12, _toDisplayString($options.t("Sélectionner un type de programme")), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filter1, (f) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: f,
                        innerHTML: $options.formatFilter(f)
                      }, null, 8 /* PROPS */, _hoisted_13))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.selectedFilter1]
                  ]),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedFilter2) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_18, _toDisplayString($options.t("Sélectionner un nom de programme")), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filter2, (f) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: f,
                        innerHTML: $options.formatFilter(f)
                      }, null, 8 /* PROPS */, _hoisted_19))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.selectedFilter2]
                  ]),
                  _hoisted_20
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.blocks, (b) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: "o-grid-4",
                      innerHTML: b.leftCol
                    }, null, 8 /* PROPS */, _hoisted_25),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: "c-admission-result__content o-text",
                        innerHTML: b.rightCol
                      }, null, 8 /* PROPS */, _hoisted_27)
                    ])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ])
  ]))
}